/**
 * 为请求增加域名
 */
export function addDomain(urls, domain) {
    let newUrls = {};
    for (let key in urls) {
        newUrls[key] = `${domain}${urls[key]}`;
    }
    return newUrls;
}
